/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Meta_DescriptionInputs */

const en_mcp_meta_description = /** @type {(inputs: Mcp_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell your AI to send text, links or files to Listening. They become audio you can play anywhere, 2 to 3x faster than reading.`)
};

const es_mcp_meta_description = /** @type {(inputs: Mcp_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pide a tu IA que envíe textos, enlaces o archivos a Listening. Se convierten en audio que puedes escuchar en cualquier lugar, de 2 a 3 veces más rápido que leyendo.`)
};

/**
* | output |
* | --- |
* | "Tell your AI to send text, links or files to Listening. They become audio you can play anywhere, 2 to 3x faster than reading." |
*
* @param {Mcp_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_meta_description = /** @type {((inputs?: Mcp_Meta_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Meta_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_meta_description(inputs)
	return en_mcp_meta_description(inputs)
});